export class User {
    activatedOn: Date;
    permissions: any;
    firstName: string;
    lastName: string;
    userID: number;
    userRole: string;
    userType: string;
    email: string;
    companyName: string;
    companyID: string;

    antiForgeryToken: string;
    
    passwordExpirationDate: Date;

    factors: Object[];
    preferredFactor: any;
    optionalFactor: any;
    oktaTransactionCode: string;
    oktaSessionToken: string;
    oktaStateToken: string;
    tokenExpiration: Date;
    mfaPhone: string;
    mfaSkipped:boolean;
    
    SID: string;
    UID: string;
    COOKIE_TOKEN_URL: string;
}
